
const toTitleCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const toCamelCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toLowerCase() + str.slice(1);
};

export {
    toTitleCase,
    toCamelCase,
}